export const isTablet = () => {
  const width = window.innerWidth;
  // Covers portrait and landscape for Lenovo Tab M10 (HD)
  return width >= 600 && width <= 1280;
};

export const detectWebDeviceType = () => {
  const ua = navigator.userAgent.toLowerCase();
  // console.log(ua,"UAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA");
  
  const width = window.innerWidth;

  const isTabletUA =
    /ipad|tablet|kindle|silk|playbook|android(?!.*mobile)/i.test(ua);

  const isPCUA =
    /windows|macintosh|linux/i.test(ua) && !/mobile|tablet|touch/i.test(ua);

  if (isTabletUA ) {
    return "tablet";
  }

  if (isPCUA) {
    return "pc";
  }


  // if (isTabletUA || (width >= 600 && width <= 1280)) {
  //   return "tablet";
  // }

  // if (isPCUA || width > 1280) {
  //   return "pc";
  // }

  return "unknown"; // optional fallback
};

